import { Separator } from '@betterment/samba-react';

import { BorderedBox } from '../BorderedBox';
import { BoxTitle } from '../BoxTitle';
import { SaleDetailsRow } from '../SaleDetailsRow';

export const AccountDetailsError: React.FC = () => {
  return (
    <BorderedBox>
      <BoxTitle>Account details</BoxTitle>
      <Separator />
      <SaleDetailsRow data-testid="account-details-row">
        <SaleDetailsRow.Label>Account</SaleDetailsRow.Label>
        <SaleDetailsRow.Value>—</SaleDetailsRow.Value>
      </SaleDetailsRow>
    </BorderedBox>
  );
};
